<div class="inline-block w-full overflow-hidden h-full">
  <div class="flex items-center justify-start">
    @if ((filteredFiles$ | async)?.length === 0) {
      <span class="w-full text-center">Attach a File to See Preview</span>
    }
    @if (filteredFiles$ | async; as filteredFiles) {
      @if (filteredFiles.length > 0) {
        <div class="flex flex-row justify-between w-full align-center">
          <div class="flex flex-row items-start">
            @if (filteredFiles.length > 1) {
              <s-ui-menubar [model]="fileMenu$ | async" class="grow" s-blur="Pii" />
              <div class="self-center lg:hidden">&Lt;Pick file to View</div>
            }
          </div>
          <div class="flex items-end">
            @if (showDelete) {
              <p-button text="true" severity="danger" (click)="deleteFile()" class="self-center"
                ><i>{{ defaultIcon.Delete.slice(3) }}</i></p-button
              >
            }
          </div>
        </div>
      }
    }
  </div>
  @if (selectedFile$ | async; as fileRef) {
    <div class="w-full h-full flex flex-wrap grow" style="min-height: 300px">
      @if (fileRef.fileType === fileType.JPG || fileRef.fileType === fileType.PNG) {
        <div class="w-full h-full">
          @if (getFileBlobPath(fileRef)) {
            <p-image
              width="100%"
              height="85%"
              [src]="getSafeFileBlobPath(fileRef)"
              alt="Image"
              [preview]="true"
              appendTo="body"
            />
          } @else {
            <p-skeleton width="100%" height="85%" />
          }
        </div>
      }
      @if (fileRef.fileType === fileType.PDF) {
        <div class="w-full h-full">
          @if (getFileBlobPath(fileRef)) {
            <ngx-extended-pdf-viewer
              [src]="getFileBlobPath(fileRef)"
              height="90%"
              width="100%"
              [textLayer]="true"
              [showHandToolButton]="true"
            />
          } @else {
            <p-skeleton width="100%" height="90%" />
          }
          <!-- 
            [useBrowserLocale]="true"
            -->
        </div>
      }
    </div>
  } @else if ((filteredFiles$ | async)?.length ?? 0 > 0) {
    <p-skeleton width="100%" height="90%" />
  }
</div>
